<template>
  <svg-icon type="mdi" :path="path"></svg-icon>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiFilePercentOutline } from '@mdi/js'

export default {
  name: 'IconMarkups',
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiFilePercentOutline
    }
  }
}
</script>
